import { Form, Input, Radio, Select } from "antd";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import svg92 from "../../../../assets/svg/svg92.svg";
import svg85 from "../../../../assets/svg/svg85.svg";

const { TextArea } = Input;
function Terms({ handleNext, handleBack, form }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const plainOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];
  const handlePrev = async () => {
    await handleBack();
  };

  async function handleSubmitStep() {
    try {
      await form.validateFields([
        "japIsAvailable",
        "japNoticePeriod",
        "japInterestDesc",
      ]);
      await handleNext();
    } catch {}
  }
  return (
    <>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          label={"Are You available Immediately?"}
          rules={[
            {
              required: true,
              message: "Please select availability",
            },
          ]}
          name="japIsAvailable"
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>

        <Form.Item
          name="japNoticePeriod"
          className=""
          label={"Notice Period (days)"}
          rules={[
            {
              required: true,
              message: "Please add notice period in days",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
      </div>

      <Form.Item
        name="japInterestDesc"
        label="Why are you interested in this position?"
        rules={[
          {
            required: true,
            message: "Enter why you are interested in this position?",
          },
        ]}
      >
        <TextArea rows={6} className="input" />
      </Form.Item>

      <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5    w-full mt-[2.5rem]">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={() => handlePrev()}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[100px]">
            <button
              key="back"
              type="button"
              className="cstm-btn-2"
              onClick={() => handlePrev()}
            >
              Cancel
            </button>
          </div>

          <div className="w-[250px]">
            <button
              key="submit"
              type="submit"
              className="cstm-btn"
              onClick={handleSubmitStep}
            >
              <span className="flex items-center  gap-x-3 ">
                Save And Proceed <img src={svg92} alt="svg92" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Terms;
